import { create } from "zustand"

interface SettingsAccountModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
}

const useSettingsAccountModalStore = create<SettingsAccountModalStore>(
  (set) => ({
    isOpen: false,
    onClose: () => set({ isOpen: false }),
    onOpen: () => set({ isOpen: true }),
  })
)

export default useSettingsAccountModalStore
